import styled from "styled-components";

export const Container = styled.div`
  width: 28%;
  height: calc(100vh - 144px);

  @media (max-width: 1580px) {
    width: 58%;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  padding: 20px 40px;
`;

export const StatusText = styled.div`
  width: 100%;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  color: rgb(120, 135, 169);
  font-family: "Inter Tight", Arial, Helvetica, sans-serif;
`;

export const StatusItem = styled.div`
  font-size: 18px;
  color: #7887a9;
  margin-top: 24px;
  font-family: "Inter Tight", Arial, Helvetica, sans-serif;
`;

export const ContainerLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

//centralização de stilos compartilhados

export const FooterContainerCenter = styled.div`
  display: flex;
  height: 40px;
  background: #d1dbe3;
  padding: 24px 30px;
  width: calc(100% - 54px);
  justify-content: flex-end;
`;

export const ButtonContainerCenter = styled.div`
  width: 74px;
`;

export const ContainerTinyCenter = styled.div`
  height: 100%;
`;
